export default __webpack_public_path__ + "static/media/blog-4.b1265e4f.jpg";